import { cloneDeep } from 'lodash';

export class CloneService {
    static clone<T> (obj: T): T {
        return cloneDeep(obj);
    }
}
